export class Concierge {
	conciergeId: number;
	name: string;
}
